import * as React from 'react';
import { Tooltip as BaseTooltip } from '@base-ui-components/react/tooltip';
import { cn } from '@/shared/lib/cn';
import styles from './Tooltip.module.css';

export const TooltipProvider = BaseTooltip.Provider;

type Side = 'top' | 'right' | 'bottom' | 'left';

export interface TooltipProps {
  content?: React.ReactNode;
  children: React.ReactElement;
  side?: Side;
  sideOffset?: number;
  disabled?: boolean;
  className?: string;
  delay?: number;
}

/**
 * Единый тултип на Base UI со стилем приложения (shadcn-подобный). Оборачивает
 * любой интерактивный элемент:
 *
 *   <Tooltip content="Согласование">
 *     <button>…</button>
 *   </Tooltip>
 *
 * @use подсказка при наведении; TooltipProvider ставится один раз в корне приложения.
 */
export function Tooltip({
  content,
  children,
  side = 'top',
  sideOffset = 6,
  disabled,
  className,
  delay,
}: TooltipProps): React.ReactElement {
  if (disabled || content == null || content === '') return children;

  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} delay={delay} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner side={side} sideOffset={sideOffset} className={styles.positioner}>
          <BaseTooltip.Popup className={cn(styles.popup, className)}>{content}</BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
